import { render, staticRenderFns } from "./IdvCallback.vue?vue&type=template&id=ea737d26&"
import script from "./IdvCallback.vue?vue&type=script&lang=js&"
export * from "./IdvCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports